import React, { useState, useEffect } from "react";
import risk_styles from './Risk.module.css';
import schoolInfo_styles from './SchoolInfo.module.css';
import PageLayout from "../components/PageLayout";
import styled from 'styled-components';
import NextButton from "../components/NextButton";
import RiskSelectionBox from "../components/RiskSelectionBox";
import QuestionBox from "../components/QuestionBox";
import NoAnswer from '../resources/no-answer-checkmark1.png';
import NoAnswerGrey from '../resources/no-answer-checkmark-grey1.png';
import DontKnowGrey from '../resources/dont-know-grey.svg';
import DontKnow from '../resources/dont-know.svg';

const FlexBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 40px;
`;

const Risk = (props) => {
  const questions = [
    // 1
    "What level of risk do you think people have of harming themselves if they have sex (oral, vaginal, or anal) without a condom or dental dam?",
    // 2
    "What level of risk do you think people have of harming themselves if they have sex while high on drugs or under the influence of alcohol?",
    // 3
    "What level of risk do you think people have of harming themselves physically or in other ways when they use tobacco once or twice a week? By tobacco, we mean menthol cigarettes, regular cigarettes, loose tobacco rolled into cigarettes or cigars, pipe tobacco, snuff, chewing tobacco, dipping tobacco, snus, and others.",
    // 4
    "What level of risk do you think people have of harming themselves physically or in other ways when they binge drink alcoholic beverages once or twice a week? Binge drinking is five or more alcoholic beverages at the same time or within a couple of hours of each other for males; four or more for females. By alcoholic beverage, we mean beer, wine, wine coolers, malt beverages, or hard liquor.",
    // 5
    "What level of risk do you think people have of harming themselves physically or in other ways when they use marijuana or hashish once or twice a week? Marijuana is sometimes called weed, blunt, hydro, grass, or pot. Hashish is sometimes called hash or hash oil.",
    // 6 (needles: share)
    "What level of risk do you think people have of harming themselves physically if they share needles, syringes, or other injection equipment when using drugs?",
    // 7 (FIXED: was a duplicate; now non‑prescription opioids)
    "What level of risk do you think people have of harming themselves physically or in other ways when they take non‑prescription opioid drugs once or twice a week?",
    // 8 (prescription opioids)
    "What level of risk do you think people have of harming themselves physically or in other ways when they take prescription opioid drugs without a doctor’s order once or twice a week? By prescription opioid drugs, we mean pain relievers such as oxycodone (OxyContin®), hydrocodone (Vicodin®), codeine, morphine, methadone, tramadol, hydromorphone, oxymorphine, tapentadol.",
    // 9 (FIXED typo: add space “inject drugs”)
    "What level of risk do you think people have of harming themselves physically when they inject drugs for nonmedical reasons?"
  ];

  const [answers, setAnswers] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [arrested, setArrested] = useState(0); // (left as-is, even if unused)

  const handleAnswerChange = (index, value) => {
    const newAnswers = [...answers];
    newAnswers[index] = value;
    setAnswers(newAnswers);
  };

  useEffect(() => {
    const filteredAnswers = answers.filter(value => value === 0);

    if (props.age > 17 && filteredAnswers.length === 0) {
      const data = {
        RSKANYSEX_UNP: answers[0],
        RSKSEX_ALCDRG: answers[1],
        RiskOfHarmWhenUsingTobaccoOnceOrTwiceWeek: answers[2],
        RSKALC: answers[3],
        RSKMJ: answers[4],
        RSKNDL_SHR: answers[5],
        // index 6 is NON‑prescription opioids (fixed question text)
        RiskOfHarmWhenUsingNonPrescriptionOpioidDrugsOnceOrTwiceWeek: answers[6],
        // index 7 is prescription opioids
        RiskOfHarmWhenUsingPrescriptionOpioidDrugsOnceOrTwiceWeek: answers[7],
        RSKNDL_INJECT: answers[8]
      };
      props.setRiskInfoData(data);
      props.setNextButton(true);
      props.onAllAnswered(false);
    } else if (filteredAnswers.length === 1) {
      const data = {
        RSKANYSEX_UNP: answers[0],
        RSKSEX_ALCDRG: answers[1],
        RiskOfHarmWhenUsingTobaccoOnceOrTwiceWeek: answers[2],
        RSKALC: answers[3],
        RSKMJ: answers[4],
        RSKNDL_SHR: answers[5],
        RiskOfHarmWhenUsingNonPrescriptionOpioidDrugsOnceOrTwiceWeek: answers[6],
        RiskOfHarmWhenUsingPrescriptionOpioidDrugsOnceOrTwiceWeek: answers[7],
        RSKNDL_INJECT: 98
      };
      props.setRiskInfoData(data);
      props.setNextButton(true);
      props.onAllAnswered(false);
    } else {
      props.setNextButton(false);
    }
  }, [answers, props]);

  return (
    <>
      <div className={risk_styles.container}>
        <h2 className={risk_styles.mainTitle}>Risk</h2>

        {questions.slice(0, -1).map((question, index) => (
          <FlexBox key={index}>
            <div className={risk_styles.title}>
              <QuestionBox
                color={props.showUnanswered && answers[index] === 0 ? 'red' : 'black'}
                question={question}
                index={index + 1}
              />
            </div>

            <RiskSelectionBox
              answers={answers}
              questionIndex={index}
              onAnswerChange={(value) => handleAnswerChange(index, value)}
            />

            <div className={schoolInfo_styles.doNotWishDiv}>
              <div style={{ textAlign: "center" }} onClick={() => handleAnswerChange(index, 97)}>
                <img
                  src={answers[index] === 97 ? NoAnswer : NoAnswerGrey}
                  className={schoolInfo_styles.icon}
                  alt=""
                />
                <div>I do not wish to answer</div>
              </div>

              <div style={{ textAlign: "center" }} onClick={() => handleAnswerChange(index, 98)}>
                <img
                  src={answers[index] === 98 ? DontKnow : DontKnowGrey}
                  className={schoolInfo_styles.icon}
                  alt=""
                />
                <div>I do not know</div>
              </div>
            </div>
          </FlexBox>
        ))}

        {props.age > 17 ? (
          <FlexBox key="last">
            <div className={risk_styles.title}>
              <QuestionBox
                color={props.showUnanswered && answers[questions.length - 1] === 0 ? 'red' : 'black'}
                question={questions[questions.length - 1]}
                index={questions.length}
              />
            </div>

            <RiskSelectionBox
              answers={answers}
              questionIndex={questions.length - 1}
              onAnswerChange={(value) => handleAnswerChange(questions.length - 1, value)}
            />

            <div className={schoolInfo_styles.doNotWishDiv}>
              <div style={{ textAlign: "center" }} onClick={() => handleAnswerChange(questions.length - 1, 97)}>
                <img
                  src={answers[questions.length - 1] === 97 ? NoAnswer : NoAnswerGrey}
                  className={schoolInfo_styles.icon}
                  alt=""
                />
                <div>I do not wish to answer</div>
              </div>

              <div style={{ textAlign: "center" }} onClick={() => handleAnswerChange(questions.length - 1, 98)}>
                <img
                  src={answers[questions.length - 1] === 98 ? DontKnow : DontKnowGrey}
                  className={schoolInfo_styles.icon}
                  alt=""
                />
                <div>I do not know</div>
              </div>
            </div>
          </FlexBox>
        ) : null}
      </div>
    </>
  );
};

export default Risk;
